import React, { FC } from 'react';
import { SkippableFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { SkipButtonGroup } from '../skip-button-group/component';
import { useSkipWithAnalytics } from '../../../hooks/skin/use-skip';

interface Props {
    className?: string;
    currentFragment: SkippableFragment;
}

export const PrerollSkipButtonGroup: FC<Props> = ({ currentFragment, className }) => {
    const { isSkipEnabled, skip, cancel } = useSkipWithAnalytics(currentFragment);

    if (!isSkipEnabled) {
        return null;
    }

    return (
        <SkipButtonGroup
            onSkipClick={skip}
            onCancelClick={cancel}
            className={className}
            hideCancelButton
        />
    );
};
